import { TConversationType } from 'src/interfaces/conversation';

interface TSenderPayload {
    from: string | null;
    api?: string;
}

interface TSender {
    provider: TConversationType | null;
    senderPhone: string | null;
}

/**
 * Completes a send payload with the channel sender when the area config did not
 * provide one (e.g. areas in `channels` mode without legacy `api`).
 */
export const applyChannelSender = <T extends TSenderPayload>(
    payload: T,
    sender: TSender
): T => ({
    ...payload,
    from: payload.from || sender.senderPhone,
    api: payload.api || sender.provider || payload.api,
});
